import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const SessionPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = searchParams.get("sessionId");

    if (sessionId) {
      localStorage.setItem("SessionUserId", sessionId);
    }

    // redirect to dashboard
    navigate("/dashboard", { replace: true });
  }, [searchParams, navigate]);

  return <div>Redirecting...</div>;
};

export default SessionPage;
